const yyglGetter = {
  getApprovelList(state) {
    return state.approvellist;
  },
  getEnterprise(state) {
    return state.enterprise;
  },
  getEnterpriseDetails(state) {
    return state.enterpriseDetails;
  },
  getEnterpriseRegister(state) {
    return state.enterpriseRegister;
  },
  getEnterpriseApprove(state) {
    return state.enterpriseApprove;
  },
  getLearnLearnapprove(state) {
    return state.learnApprove;
  },
  getLearnExpirJfApprove(state) {
    return state.learnExpirJfApprove;
  },
  getLearnApproveCount1(state) {
    return state.learnApproveCount1;
  },
  getLearnApproveCount2(state) {
    return state.learnApproveCount2;
  },
  getLearnApproveCount3(state) {
    return state.learnApproveCount3;
  },
  getJCYLearnApproveCount1(state) {
    return state.jcyLearnApproveCount1;
  },
  getJCYLearnApproveCount2(state) {
    return state.jcyLearnApproveCount2;
  },
  getMakeUpMakeUpApprove(state) {
    return state.makeUpApprove;
  },
  getMakeUpApproveCount1(state) {
    return state.makeUpApproveCount1;
  },
  getMakeUpApproveCount2(state) {
    return state.makeUpApproveCount2;
  },
  getMakeUpApproveCount3(state) {
    return state.makeUpApproveCount3;
  },
  getPendingApprovalCount(state) {
    return state.pendingApprovalCount;
  },
  getLearningmgtYY(state) {
    return state.learningmgtYY;
  },
  getLearningmgt(state) {
    return state.learningmgt;
  },
  getLearningmgtEmployee(state) {
    return state.learningmgtEmployee;
  },
  getLearningmgtEmployeeMockExamRecords(state) {
    return state.learningmgtEmployeeMockExamRecords;
  },
  getLearningmgtEmployeeLesson(state) {
    return state.learningmgtEmployeeLesson;
  },
  getLearningmgtEmployeeLessonCatalogs(state) {
    return state.learningmgtEmployeeLessonCatalogs;
  },
  getLearningMGTEmployeeLessonAlbumDetails(state) {
    return state.learningMGTEmployeeLessonAlbumDetails;
  },
  getLearningmgtEmployeeLessonLog(state) {
    return state.learningmgtEmployeeLessonLog;
  },
  getSearchexporTemployeeList(state) {
    return state.temployeeList;
  },
  getExportJcy2026Employees(state) {
    return state.exportJcy2026Employees;
  },
  getExportEmployeeExcel(state) {
    return state.exportEmployeeExcel;
  },
  getLearnApproveExportBdyExcel(state) {
    return state.learnApproveExportBdyExcel;
  },
  getLearnApproveExportBdyZpZip(state) {
    return state.learnApproveExportBdyZpZip;
  },
  getLearnApproveExportBdyHzbExcel(state) {
    return state.learnApproveExportBdyHzbExcel;
  },
  getLearnApproveExportJsgrExcel(state) {
    return state.learnApproveExportJsgrExcel;
  },
  getLearnEnterprise(state) {
    return state.learnEnterprise;
  },
  getExportEmployeeZp(state) {
    return state.exportEmployeeZp;
  },
  getExportBdyExcel(state) {
    return state.exportBdyExcel;
  },
  getExportJsgrExcel(state) {
    return state.exportJsgrExcel;
  },
  getYYHasCourse(state) {
    return state.yyHasCourse;
  },
  getLearnApproveExportExcel(state) {
    return state.learnapproveExportExcel;
  },
  getLearnApproveExportEmployeeExcel(state) {
    return state.learnapproveExportEmployeeExcel;
  },
  exportLearnBdyBMExcel(state) {
    return state.learnBdyBMExcel;
  },
  getMakeUpApproveExportApproveExcel(state) {
    return state.exportMakeUpApproveExcel;
  },
  getMakeUpApproveExportjfApproveExcel(state) {
    return state.exportMakeUpjfApproveExcel;
  },

  getTestRooms(state) {
    return state.testRooms;
  },
  getTestRoomById(state) {
    return state.testRoom;
  },

  getTestBatchs(state) {
    return state.testBatchs;
  },
  getTestBatchDetailsById(state) {
    return state.testBatchDetails;
  },
  getCourseTestBatchs(state) {
    return state.courseTestBatchs;
  },
  getTestBatchEmployees(state) {
    return state.testBatchEmployees;
  },
  getTestBatchAddEmployees(state) {
    return state.testBatchAddEmployees;
  },
  getTestBatchJobStats(state) {
    return state.testBatchJobStats;
  },
  exportTestBatchEmployeeExcel(state) {
    return state.testBatchEmployeeExcel;
  },

  getTestTrains(state) {
    return state.testTrains;
  },
  getCourseTestTrains(state) {
    return state.courseTestTrains;
  },
  getTestTrainDetailsById(state) {
    return state.testTrainDetails;
  },
  getTestTrainEmployees(state) {
    return state.testTrainEmployees;
  },
  exportTestTrainEmployeeExcel(state) {
    return state.testTrainEmployeeExcel;
  },
  exportTestTrainLessonExcel(state) {
    return state.testTrainLessonExcel;
  },
  exportTestTrainEmployeeZp(state) {
    return state.testTrainEmployeeZp;
  },

  getTestSessionStates(state) {
    return state.testSessionStates;
  },
  getTestSessions(state) {
    return state.testSessions;
  },
  getTestSessionDetailsById(state) {
    return state.testSessionDetails;
  },
  getTestSessionEmployees(state) {
    return state.testSessionEmployees;
  },
  getTestSessionEmployeeAdmissionTicketUrl(state) {
    return state.testSessionEmployeeAdmissionTicketUrl;
  },
  getTestSessionAddEmployees(state) {
    return state.testSessionAddEmployees;
  },
  exportTestSessionEmployeeExcel(state) {
    return state.testSessionEmployeeExcel;
  },
  exportTestSessionTestExcel(state) {
    return state.testSessionTestExcel;
  },
  getZjpxTrains(state) {
    return state.zjpxTrains;
  },

  getZjyTestBatchs(state) {
    return state.zjyTestBatchs;
  },
  getZjyTestBatchDetailsById(state) {
    return state.zjyTestBatchDetails;
  },
  getZjyTestBatchEmployees(state) {
    return state.zjyTestBatchEmployees;
  },
  getZjyTestBatchApproveEmployees(state) {
    return state.zjyTestBatchApproveEmployees;
  },
  getZjyTestBatchApproveEmployeeCount(state) {
    return state.zjyTestBatchApproveEmployeeCount;
  },

  getEnterprises(state) {
    return state.enterprises;
  },
  getEnterpriseLearns(state) {
    return state.enterpriseLearns;
  },
  getEnterpriseTests(state) {
    return state.enterpriseTests;
  },
  getEnterpriseEmployees(state) {
    return state.enterpriseEmployees;
  },
  getEnterpriseZjyTestDetails(state) {
    return state.enterpriseZjyTestDetails;
  },
  getEnterpriseZjyTestEmployees(state) {
    return state.enterpriseZjyTestEmployees;
  },
  getEnterpriseZjyTestEmployeeRecord(state) {
    return state.enterpriseZjyTestEmployeeRecord;
  },
  getEnterpriseBdyTestDetails(state) {
    return state.enterpriseBdyTestDetails;
  },
  getEnterpriseBdyTestEmployees(state) {
    return state.enterpriseBdyTestEmployees;
  },
  getEnterpriseBdyTestEmployeeRecord(state) {
    return state.enterpriseBdyTestEmployeeRecord;
  },

  getYYInvoiceApproves(state) {
    return state.invoiceApproves;
  },
  getInvoiceApproveCount1(state) {
    return state.invoiceApproveCount1;
  },
  getInvoiceApproveCount2(state) {
    return state.invoiceApproveCount2;
  },
  getInvoiceApproveCount3(state) {
    return state.invoiceApproveCount3;
  },
  getInvoiceApproveCount4(state) {
    return state.invoiceApproveCount4;
  },
  getInvoiceMandatoryLearns(state) {
    return state.invoiceMandatoryLearns;
  },
  getNewsTestPlan(state) {
    return state.newsTestPlan;
  },
  getNewsTestPlanTypes(state) {
    return state.newsTestPlanTypes;
  },

  getNewsCategorys(state) {
    return state.newsCategorys;
  },
  getNewsYY(state) {
    return state.newsYY;
  },

  getEmployees(state) {
    return state.employees;
  },
  getEmployeeDetails(state) {
    return state.employeeDetails;
  },
  getEmployeeMnksLearns(state) {
    return state.employeeMnksLearns;
  },
  getEmployeeLearns(state) {
    return state.employeeLearns;
  },
  getEmployeeTests(state) {
    return state.employeeTests;
  },
  getEmployeePractices(state) {
    return state.employeePractices;
  },

  getCerts(state) {
    return state.certs;
  },
  getCertStats(state) {
    return state.certStats;
  },
  getCertSources(state) {
    return state.certSources;
  },
  getCertDetails(state) {
    return state.certDetails;
  },

  getJsgrTestBatchs(state) {
    return state.jsgrTestBatchs;
  },
  getAllJsgrTestBatchs(state) {
    return state.allJsgrTestBatchs;
  },
  getJsgrTestBatchJobStats(state) {
    return state.jsgrTestBatchJobStats;
  },
  getJsgrTestBatchEmployees(state) {
    return state.jsgrTestBatchEmployees;
  },

  getJsgrTestTrains(state) {
    return state.jsgrTestTrains;
  },
  getAllJsgrTestTrains(state) {
    return state.allJsgrTestTrains;
  },
  getJsgrTestTrainEmployees(state) {
    return state.jsgrTestTrainEmployees;
  },
  exportJsgrTestTrainEmployeeExcel(state) {
    return state.jsgrTestTrainEmployeeExcel;
  },
  exportJsgrTestTrainLessonExcel(state) {
    return state.jsgrTestTrainLessonExcel;
  },

  getJsgrTestSessions(state) {
    return state.jsgrTestSessions;
  },
  getJsgrTestSessionDetailsById(state) {
    return state.jsgrTestSessionDetails;
  },
  getJsgrTestSessionEmployees(state) {
    return state.jsgrTestSessionEmployees;
  },
  getAddJsgrTestSessionEmployees(state) {
    return state.addJsgrTestSessionEmployees;
  },
  exportJsgrTestSessionEmployeeExcel(state) {
    return state.jsgrTestSessionEmployeeExcel;
  },

  getBdyTestPlanBatchs(state) {
    return state.bdyTestPlanBatchs;
  },
  getBdyTestPlanBatchJobStats(state) {
    return state.bdyTestPlanBatchJobStats;
  },
  getBdyTestPlanBatchSessions(state) {
    return state.bdyTestPlanBatchSessions;
  },

  getBdyTestBatchs(state) {
    return state.bdyTestBatchs;
  },
  getBdyTestBatchJobStats(state) {
    return state.bdyTestBatchJobStats;
  },
  getBdyTestBatchDetails(state) {
    return state.bdyTestBatchDetails;
  },
  exportBdyTestBatchEmployeeExcel(state) {
    return state.bdyTestBatchEmployeeExcel;
  },

  getBdyTestSessions(state) {
    return state.bdyTestSessions;
  },
  getBdyTestSessionJobStats(state) {
    return state.bdyTestSessionJobStats;
  },
  getBdyTestSessionDetails(state) {
    return state.bdyTestSessionDetails;
  },
  getBdyTestSessionEmployees(state) {
    return state.bdyTestSessionEmployees;
  },
  exportBdyTestSessionKcybExcel(state) {
    return state.bdyTestSessionKcybExcel;
  },
  exportBdyTestSessionEmployeeExcel(state) {
    return state.bdyTestSessionEmployeeExcel;
  },

  getExamBatchs(state) {
    return state.examBatchs;
  },
  getExamBatchCourses(state) {
      return state.examBatchCourses;
  },
  getExamBatchJobStats(state) {
    return state.examBatchJobStats;
  },
  getExamBatchDetails(state) {
    return state.examBatchDetails;
  },
  exportExamBatchEmployeeExcel(state) {
    return state.examBatchEmployeeExcel;
  },
  exportExamBatchSpbExcel(state) {
    return state.examBatchSpbExcel;
  },

  getExamSessions(state) {
    return state.examSessions;
  },
  getExamSessionCourses(state) {
      return state.examSessionCourses;
  },
  getExamSessionJobStats(state) {
    return state.examSessionJobStats;
  },
  getExamSessionDetails(state) {
    return state.examSessionDetails;
  },
  getExamSessionEmployees(state) {
    return state.examSessionEmployees;
  },
  exportExamSessionKcybExcel(state) {
    return state.examSessionKcybExcel;
  },
  exportExamSessionEmployeeExcel(state) {
    return state.examSessionEmployeeExcel;
  },
  exportExamSessionScoreTemplateExcel(state) {
    return state.examSessionScoreTemplateExcel;
  },
  getExamPaperDetails(state) {
    return state.examPaperDetails;
  },
  getExamPaperApproves(state) {
    return state.examPaperApproves;
  },
  getCert(state) {
    return state.cert;
  },

  getEnterpriseModifyApprovesYY(state) {
    return state.enterpriseModifyApprovesYY;
  },
  getPendingModifyApprovalCount(state) {
    return state.pendingModifyApprovalCount;
  },

  getBdyPracticeEnrolls(state) {
    return state.bdyPracticeEnrolls;
  },
  getBdyPracticeEnrollApprovalCount(state) {
    return state.bdyPracticeEnrollApprovalCount;
  },
  getBdyPracticeEnrollStates(state) {
    return state.gbdyPracticeEnrollStates;
  },
  getBdyPracticeEnrollDetails(state) {
    return state.bdyPracticeEnrollDetails;
  },

  getQuestionYYs(state) {
    return state.questionYYs;
  },
  getBdyQuestions(state) {
    return state.bdyQuestions;
  },

  getLearnInvoices(state) {
    return state.learnInvoices;
  },
  getLearnInvoiceGkDKPCount(state) {
    return state.learnInvoiceGkDKPCount;
  },
  getLearnInvoicePxDKPCount(state) {
    return state.learnInvoicePxDKPCount;
  },
  getLearnInvoiceDetails(state) {
    return state.learnInvoiceDetails;
  },
  getLearnInvoiceStates(state) {
    return state.learnInvoiceStates;
  },
  expertLearnInvoiceDpwj(state) {
    return state.learnInvoiceDpwj;
  },
  expertLearnInvoiceDpExcel(state) {
    return state.learnInvoiceDpExcel;
  },

  getApproveCertReplaces(state) {
    return state.approveCertReplaces;
  },
  getCertReplaceApproves(state) {
    return state.certReplaceApproves;
  },
  getApproveCertReplaceCount1(state) {
    return state.approveCertReplaceCount1;
  },
  getApproveCertReplaceCount2(state) {
    return state.approveCertReplaceCount2;
  },
  getCertReplaceApproveActions(state) {
    return state.certReplaceApproveActions;
  },

  getAllEmployeeChangeApproves(state) {
    return state.allEmployeeChangeApproves;
  }
};

export default yyglGetter;



// WEBPACK FOOTER //
// ./src/store/jzjy/getters/yyglGetter.js